import React from 'react';
import { Link } from 'react-router-dom';

export default function ChannelTrialNotice({ until, tenantId }) {
  if (!until) return null;
  const date = new Date(until).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
  return (
    <p className="rounded-md bg-indigo-50 px-3 py-2 text-sm text-indigo-900">
      Included in your trial until {date}.{' '}
      <Link to={`/t/${tenantId}/billing`} className="font-semibold underline">
        Add it in Billing to keep it.
      </Link>
    </p>
  );
}
